



















import { Component, Prop, Vue } from 'vue-property-decorator';

import * as def from '@/definitions'
import { Layer } from '@/model/document2/page/surface/design/layer/layer';
import { LineLayer } from '@/model/document2/page/surface/design/layer/lineLayer';
import { Vector2 } from '@/utilityModels/vector2';

import { UserAgentHelper } from '@/helper/userAgentHelper';

@Component({
    components: {
    },
})
export default class LineController extends Vue 
{
    private get isMobile() { return UserAgentHelper.isMobile(); }

    // 円の半径
    CIRCLE_RADIUS : number = 5;

    @Prop() private layer! : Layer | null;
    @Prop() private scale! : number;
    @Prop() private offsetX! : number;
    @Prop() private offsetY! : number;
    @Prop() private cursorWidth! : number;
    @Prop() private cursorHeight! : number;
    
    private get sx()
    {
        if(this.layer == null || !(this.layer instanceof LineLayer)) { return 0; }
        return this.layer.startX * this.scale + this.offsetX;
    }

     private get sy()
    {
        if(this.layer == null || !(this.layer instanceof LineLayer)) { return 0; }
        return this.layer.startY * this.scale + this.offsetY;
    }

    private get ex()
    {
        if(this.layer == null || !(this.layer instanceof LineLayer)) { return 0; }
        return this.layer.endX * this.scale + this.offsetX;
    }

    private get ey()
    {
        if(this.layer == null || !(this.layer instanceof LineLayer)) { return 0; }
        return this.layer.endY * this.scale + this.offsetY;
    }

    private get r()
    {
        return this.cursorWidth / 2;
    }

    // 始点選択
    private selectStartPoint()
    {
        this.$emit("selectStartPoint");
    }

    // 終点選択
    private selectEndPoint()
    {
        this.$emit("selectEndPoint");
    }
}
